import { useState } from 'react';

export const useStatefulRef = <T = any>() => {
	const [ref, setRef] = useState<T | null>(null);

	return [ref, setRef] as const;
};
